<template>
  <q-list :dense="dense" style="min-width: 200px">
    <slot />
  </q-list>
</template>

<script>
export default {
  name: 'CList',
  props: {
    dense: Boolean,
  },
};
</script>

<style scoped></style>
